module.exports = __webpack_public_path__ + "static/media/icon-keypad.8b7aedd4.svg";